import { Pipe, PipeTransform } from '@angular/core';
import { orderBy } from 'lodash';

@Pipe({
  name: 'sortByOrder'
})
export class SortByOrderPipe implements PipeTransform {

  transform(value: any, orderKey: string) {
    const orderedList = orderBy(value, orderKey, 'asc');
    return  orderedList
  }

}
